/** Délais avant chaque nouvelle tentative : 3 envois au plus, tous avec le même eventId. */
export const ANALYTICS_RETRY_DELAYS_MS: readonly number[] = [1000, 3000];

type UuidSource = {
  randomUUID?: () => string;
  getRandomValues?: <T extends ArrayBufferView | null>(array: T) => T;
};

/** UUID v4 ; `randomUUID` manque sur les Safari antérieurs à 15.4 et hors contexte sécurisé. */
export function createAnalyticsEventId(
  source: UuidSource | undefined = globalThis.crypto as UuidSource | undefined,
  random: () => number = Math.random,
): string {
  if (typeof source?.randomUUID === 'function') return source.randomUUID();
  const bytes = new Uint8Array(16);
  if (typeof source?.getRandomValues === 'function') {
    source.getRandomValues(bytes);
  } else {
    for (let index = 0; index < bytes.length; index++) bytes[index] = Math.floor(random() * 256);
  }
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

/**
 * Seuls les échecs transitoires sont retentés : réseau ou timeout (aucun statut), 408, 424 (Redis ou
 * Pub/Sub indisponible côté live-api), 429 et 5xx. Une réponse métier (400, 401, 403, 404) est définitive.
 */
export function isRetryableAnalyticsError(error: unknown): boolean {
  if (error === null || typeof error !== 'object') return true;
  const { status } = error as { status?: number };
  if (status === undefined) return true;
  return status === 408 || status === 424 || status === 429 || status >= 500;
}
